module.exports = __webpack_public_path__ + "static/media/mobiledev.af6f3aa3.svg";